import { Loader2 } from "lucide-react";
import { forwardRef } from "react";

import { Button } from "@/components/ui/button";

export const LoadingButton = forwardRef<
  HTMLButtonElement,
  React.ComponentProps<typeof Button> & { isLoading?: boolean }
>(({ disabled, isLoading, children, ...rest }, ref) => {
  return (
    <Button ref={ref} disabled={isLoading || disabled} {...rest}>
      {isLoading && <Loader2 className="size-4 animate-spin" />}
      {children}
    </Button>
  );
});

LoadingButton.displayName = "LoadingButton";
